<template>
  <component
    :is="isLink ? 'a' : 'article'"
    :href="safeHref"
    :aria-label="isLink ? card.ariaLabel : null"
    class="author-media-card"
  >
    <span class="author-media-card__cover">
      <img
        v-if="card.image"
        :src="card.image"
        :alt="card.title"
        class="author-media-card__image"
        :loading="card.loading || 'lazy'"
      >
    </span>
    <span class="author-media-card__title" :title="card.title">{{ card.title }}</span>
  </component>
</template>

<script>
import { sanitizeHttpUrl } from '@/utils/safeNavigation';

export default {
  name: 'AuthorMediaCard',
  props: {
    card: {
      type: Object,
      required: true,
    },
  },
  computed: {
    safeHref() {
      return sanitizeHttpUrl(this.card.href);
    },
    isLink() {
      return Boolean(this.safeHref);
    },
  },
};
</script>

<style scoped>
.author-media-card {
  display: block;
  min-width: 0;
  color: var(--author-foreground);
  text-decoration: none;
  border-radius: 14px;
  transition: transform 350ms cubic-bezier(0.2, 0, 0, 1);
}

.author-media-card__cover {
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: 2 / 3;
  overflow: hidden;
  background: var(--author-surface-soft);
  border: 1px solid var(--author-border);
  border-radius: 14px;
  box-shadow: var(--author-shadow);
  transition: border-color 180ms ease;
}

.author-media-card__cover::after {
  position: absolute;
  inset: 0;
  content: '';
  pointer-events: none;
  background: linear-gradient(to top, rgba(13, 7, 18, 0.28), transparent 38%);
  outline: 1px solid rgba(255, 255, 255, 0.08);
  outline-offset: -1px;
}

.author-media-card__image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 500ms cubic-bezier(0.2, 0, 0, 1);
}

.author-media-card__title {
  display: block;
  margin-top: 8px;
  overflow: hidden;
  color: var(--author-foreground);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.author-media-card:focus-visible {
  outline: 3px solid var(--author-focus);
  outline-offset: 4px;
}

@media (hover: hover) and (pointer: fine) {
  .author-media-card:hover {
    transform: translateY(-6px) scale(1.01);
  }

  .author-media-card:hover .author-media-card__image {
    transform: scale(1.05);
  }

  .author-media-card:hover .author-media-card__cover {
    border-color: rgba(255, 207, 90, 0.7);
  }
}

@media (prefers-reduced-motion: reduce) {
  .author-media-card,
  .author-media-card__image {
    transition-duration: 0ms !important;
  }

  .author-media-card:hover,
  .author-media-card:hover .author-media-card__image {
    transform: none !important;
  }
}
</style>
